export function getFiniteReviewProgressScore(
  progressScore: number | null | undefined,
  fallbackProgressScore: number = 0
): number {
  if (Number.isFinite(progressScore)) {
    return progressScore;
  }

  return Number.isFinite(fallbackProgressScore) ? fallbackProgressScore : 0;
}

export function calculateReviewProgressPercentage(
  currentDeckProgressScore: number | null | undefined,
  maxDeckProgressScore: number | null | undefined
): number {
  const finiteCurrentDeckProgressScore = getFiniteReviewProgressScore(currentDeckProgressScore);
  const finiteMaxDeckProgressScore = getFiniteReviewProgressScore(maxDeckProgressScore);

  if (finiteMaxDeckProgressScore <= 0) {
    return 0;
  }

  const progressPercentage = (finiteCurrentDeckProgressScore / finiteMaxDeckProgressScore) * 100;
  return Math.min(100, Math.max(0, progressPercentage));
}
